import { createContext } from "preact";
import { UserServiceInterface } from "../interfaces";

export const UserServiceContext = createContext<UserServiceInterface | null>(null)